export class MetaDataStore {
  constructor(modelJson) {
    this.intact = modelJson;
    this._setCurrent();
    this.cache = new Map();
  }

  _setCurrent() {
    this.current = JSON.parse(JSON.stringify(this.intact));
  }

  getAll() {
    return this.current;
  }

  get(id) {
    return this.current[id] || null;
  }

  revert() {
    this._setCurrent();
  }

  commit() {
    this.intact = JSON.parse(JSON.stringify(this.current));
  }
}
